// import {currentCart} from '@netx/core-cart/singletons/currentCart';

export const currentCartIsEmpty = () => !Netx.cart.current.getTotal();

export default currentCartIsEmpty;
